var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('b-row',[_c('b-col',[_c('user-profile')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }